/**
 * @file Detail/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

export const CONTENTITEM_TYPE_STORY = "story";
export const CONTENTITEM_TYPE_SEGMENT = "segment";
export const CONTENTITEM_TYPE_BLOGENTRY = "blogentry";
export const CONTENTITEM_TYPE_EPISODE = "episode";
export const CONTENTITEM_TYPE_FEATURE = "feature";
export const CONTENTITEM_TYPE_PHOTOGALLERY = "photogallery";
export const CONTENTITEM_TYPE_SPONSORED_CONTENT = "sponsoredcontent";
export const CONTENTITEM_TYPE_RECIPE = "recipe";
export const CONTENTITEM_TYPE_AUDIO = "audio";
export const CONTENTITEM_TYPE_VIDEO = "video";

export const CONTENT_TYPES = [
    CONTENTITEM_TYPE_STORY,
    CONTENTITEM_TYPE_SEGMENT,
    CONTENTITEM_TYPE_BLOGENTRY,
    CONTENTITEM_TYPE_EPISODE,
    CONTENTITEM_TYPE_FEATURE,
    CONTENTITEM_TYPE_SPONSORED_CONTENT,
    CONTENTITEM_TYPE_PHOTOGALLERY,
    CONTENTITEM_TYPE_RECIPE,
    CONTENTITEM_TYPE_AUDIO,
    CONTENTITEM_TYPE_VIDEO,
];

export const MOBILE_AD_INDEX_ARRAY = Array.from(
    { length: 30 },
    (v, i) => 4 + i * 6
);
export const DESKTOP_AD_INDEX_ARRAY = Array.from(
    { length: 30 },
    (v, i) => 4 + i * 10
);

export const DISCOVERY_ORDER = [
    "trendingVideos",
    "recommendations",
    "comments",
    "discoverMore",
];
export const SIDEBAR_ORDER = ["trending"];

export const MORE_FROM_THIS_EPISODE = "More from this episode";
